import {createAction} from "@reduxjs/toolkit";

export const setSettlementPageFilter = createAction<{dttm: number}>("ui/settlement-page/setFilter");
